module.exports = __webpack_public_path__ + "static/media/photo.5fe5e041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/photo.svg
// module id = 1226
// module chunks = 0